import React from 'react';

type UserOnlineMeetingsProps = {};

const UserOnlineMeetings = (props: UserOnlineMeetingsProps) => {
  return <div>UserOnlineMeetings</div>;
};

export default UserOnlineMeetings;
